import { getGradeFromScore } from '../analysis/scores';
import type { GapStructure } from './types';

/** Count gaps across both array and object structures */
export function countGaps(gaps: unknown[] | GapStructure | undefined | null): number {
  if (!gaps) return 0;
  if (Array.isArray(gaps)) return gaps.length;
  if (typeof gaps === 'object') {
    let count = 0;
    if (Array.isArray(gaps.missing)) count += gaps.missing.length;
    if (Array.isArray(gaps.incomplete)) count += gaps.incomplete.length;
    if (Array.isArray(gaps.opportunities)) count += gaps.opportunities.length;
    if (Array.isArray(gaps.risks)) count += gaps.risks.length;
    return count;
  }
  return 0;
}

/** Grade-colored background/text/border Tailwind classes */
export function getGradeStyles(score: number): { bg: string; text: string; border: string } {
  const grade = getGradeFromScore(score);
  switch (grade) {
    case 'A':
      return {
        bg: 'bg-emerald-50 dark:bg-emerald-950',
        text: 'text-emerald-700 dark:text-emerald-300',
        border: 'border-emerald-200 dark:border-emerald-800',
      };
    case 'B':
      return {
        bg: 'bg-blue-50 dark:bg-blue-950',
        text: 'text-blue-700 dark:text-blue-300',
        border: 'border-blue-200 dark:border-blue-800',
      };
    case 'C':
      return {
        bg: 'bg-amber-50 dark:bg-amber-950',
        text: 'text-amber-700 dark:text-amber-300',
        border: 'border-amber-200 dark:border-amber-800',
      };
    case 'D':
      return {
        bg: 'bg-orange-50 dark:bg-orange-950',
        text: 'text-orange-700 dark:text-orange-300',
        border: 'border-orange-200 dark:border-orange-800',
      };
    default:
      return {
        bg: 'bg-red-50 dark:bg-red-950',
        text: 'text-red-700 dark:text-red-300',
        border: 'border-red-200 dark:border-red-800',
      };
  }
}

/** Format task_class identifiers into display names */
export function formatTaskClass(taskClass: string): string {
  return taskClass.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}
